import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useFormattedDuration } from "@/hooks/metrics/useFormattedDuration";
import { LicenseCheckDisplayData } from "@/pages/license-check-admin/models/LicenseCheckDisplayData";

export function DurationCell(props: GridRenderCellParams<LicenseCheckDisplayData>) {
  const formatted = useFormattedDuration(props.value);

  return <>{formatted}</>;
}
